import { getSchoolConfig } from '../../../../utils/sessionStorage/schoolConfig'
import getQuestionType from '../../../../utils/getQuestionType'
import Question from '../../../../components/Question/Question'
import { useInitDataContext } from '../../../../contexts/initDataContext'
import { useState, useEffect } from 'react'

const EmergencyPersonPage = () => {
  const school = getSchoolConfig()
  const progressStep = 1
  const { flow } = useInitDataContext()

  // emergency question flow
  const [currentFlow, setCurrentFlow] = useState(flow?.emergency)

  // have to set this in a useEffect because it isn't there initially
  useEffect(() => {
    setCurrentFlow(flow?.emergency)
  }, [flow])

  // short circuit if questions are null
  if (currentFlow == null) return null

  // since this is the first question in the list always (due to the routing), we can safely assume
  // that the questionIndex is 0 for this component. in [question] it is dynamic
  const firstQuestion = currentFlow[0]

  const nextQuestion = currentFlow[1]

  return (
    <Question
      goToResources={currentFlow.length === 1}
      isAccessCriteriaQuestion={true}
      nextQuestionId={nextQuestion?.id}
      progressStep={progressStep}
      questionObject={firstQuestion}
      school={school}
      triage_logo={school.flagImage}
      type={getQuestionType(firstQuestion)}
    />
  )
}

export default EmergencyPersonPage
